<template>
  <div ref="crudTableFitRoot" :data-testid="getTestId('project-crud-container')">
    <v-data-table
      :headers="headers"
      :items="projects"
      class="elevation-1"
      :data-testid="getTestId('project-data-table')"
      hide-default-footer
      :loading="apiLoading"
      :custom-sort="customSort"
      :loading-text="$t('fileDetail.loadingData')"
      :options.sync="tableOptions"
      @update:options="changedOptions"
    >
      <template v-slot:top>
        <v-toolbar flat class="solvit-crud-table-toolbar" :data-testid="getTestId('project-toolbar')">
          <v-toolbar-title style="align-items: center; display: flex"
            ><v-icon left>mdi-projector-screen-outline</v-icon>{{ $t('project.pageTitle') }}</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('project.searchField')"
            single-line
            hide-details
            :data-testid="getTestId('project-search-input')"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            style="font-weight: 400"
            class="mb-2 solvit-crud-outline-btn solvit-crud-outline-btn--primary"
            :data-testid="getTestId('project-add-button')"
            @click="openAddDialog"
          >
            <v-icon size="medium">mdi-plus</v-icon>
            {{ $t('common.addNew') }}
          </v-btn>
        </v-toolbar>
        <v-dialog
          v-model="dialog"
          :max-width="modalLayout.MD"
          v-bind="modalP2FormViewport"
          @keydown.esc="close"
          :data-testid="getTestId('project-dialog')"
        >
            <v-card>
              <CrudFormDialogHeader
                :kicker="$t('project.pageTitle')"
                :title="formTitle"
              />
              <v-card-text>
                <v-container>
                  <v-row>
                    <!-- <v-text-field v-model="editedItem.name" label="Dessert name"></v-text-field> -->
                    <v-col cols="2" class="custom-padding">
                      <label>{{ $t('project.projects') }}</label>
                    </v-col>
                    <v-col cols="10" class="custom-padding">
                      <v-text-field
                        v-model="editedItem.name"
                        dense
                        :data-testid="getTestId('project-name-input')"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2" class="custom-padding">
                      <label>{{ $t('common.description') }}</label>
                    </v-col>
                    <v-col cols="10" class="custom-padding">
                      <!-- <v-text-field v-model="editedItem.calories" label="Calories"></v-text-field> -->
                      <v-textarea
                        v-model="editedItem.description"
                        outlined
                        dense
                        :data-testid="getTestId('project-description-input')"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined class="solvit-crud-outline-btn" :data-testid="getTestId('project-cancel-button')" @click="close">{{ $t('common.cancel') }}</v-btn>
                <v-btn outlined class="solvit-crud-outline-btn solvit-crud-outline-btn--primary" :data-testid="getTestId('project-save-button')" @click="save">{{ $t('common.save') }}</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.actions="{ item }">
        <fix-delete-btn
          :item="item"
          @editItem="editItem"
          @deleteItem="deleteItem"
          :data-testid="getTestId('project-action-buttons')"
        />
      </template>
      <template v-slot:no-data>
        <v-btn outlined class="solvit-crud-outline-btn" :data-testid="getTestId('project-refresh-button')" @click="initialize">{{ $t('fileDetail.refresh') }}</v-btn>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="10"
        next-icon="mdi-chevron-right"
        prev-icon="mdi-chevron-left"
        :data-testid="getTestId('project-pagination')"
      ></v-pagination>
    </div>

    <!--		<v-dialog-->
    <!--			v-model="progressDialog"-->
    <!--			hide-overlay-->
    <!--			persistent-->
    <!--			width="300"-->
    <!--		>-->
    <!--			<v-card color="primary">-->
    <!--				<v-card-text>-->
    <!--					데이터 처리 중...-->
    <!--					<v-progress-linear-->
    <!--						indeterminate-->
    <!--						color="white"-->
    <!--						class="mb-0"-->
    <!--					></v-progress-linear>-->
    <!--				</v-card-text>-->
    <!--			</v-card>-->
    <!--		</v-dialog>-->
  </div>
</template>

<script>
import Api from "../../apis/Api";
import FixDeleteBtn from "../button/FixDeleteBtn.vue";
import CrudFormDialogHeader from "@/components/common/CrudFormDialogHeader.vue";
import { mapGetters } from "vuex";
import { getSortParam } from "../../utils/sortUtils";
import { getTestId } from "@/utils/testUtils";
import { debounce } from "@/utils/simpleDebounce";
import { 
  createDefaultTableOptions, 
  buildSortParam, 
  buildPaginationParams, 
  buildApiUrl, 
  transformApiResponse 
} from "../../utils/tableUtils";
import { transformToProjectTableItems } from "../../constants/projectTableItem";
import { MODAL_MAX_WIDTH, MODAL_P2_FORM_VIEWPORT } from "@/constants/modalLayout";
import { crudTablePageSizeFitMixin } from "@/ui/mixins/crudTablePageSizeFitMixin";

export default {
  name: "ProjectCrudTable",
  mixins: [crudTablePageSizeFitMixin],
  components: {
    FixDeleteBtn,
    CrudFormDialogHeader,
  },
  data: () => ({
    modalLayout: MODAL_MAX_WIDTH,
    modalP2FormViewport: MODAL_P2_FORM_VIEWPORT,
    // tableUtils를 사용한 기본 테이블 옵션 생성 (created에서 viewport fit로 덮어씀)
    tableOptions: createDefaultTableOptions(['id'], [true], 10),
    
    // 기존 변수들은 유지 (하위 호환성)
    sortBy: ["id"],
    sortDesc: [true],
    // progressDialog:false,
    itemsPerPage: 10,
    pageCount: 0,
    paging: true,
    page: 1,
    domain: "projects",
    dialog: false,
    search: "",
    projects: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      description: "",
      owner: undefined,
    },
    defaultItem: {
      name: "",
      description: "",
    },
    apiLoading: true,
  }),
  computed: {
    ...mapGetters({ userProfile: "user/getUserProfile" }),
    headers() {
      void this.$i18n.locale;
      return [
        { text: this.$t("project.tableProjectName"), value: "name" },
        { text: this.$t("common.description"), value: "description" },
        { text: this.$t("common.editOrDelete"), value: "actions", sortable: false }
      ];
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$t("common.addNew") : this.$t("common.edit");
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    search(val) {
      // 검색어 변경 시에만 debounce 적용
      this.debouncedSearch(val, 1, this.sortBy, this.sortDesc);
    },
    page(val) {
      if (this.isCrudTableFitProgrammaticUpdate()) {
        return;
      }
      this.page = val;
      // 페이지 변경은 즉시 실행
      this.searchProjectData(this.search, val, this.sortBy, this.sortDesc);
    },
  },
  created() {
    //changedOptions에서 실행
    // this.initialize();
    
    // 간단한 debounce 함수 생성
    this.debouncedSearch = debounce(this.searchProjectData, 200);
  },
  mounted() {
    // 초기 정렬 옵션을 명시적으로 설정
    this.tableOptions.sortBy = ['id'];
    this.tableOptions.sortDesc = [true];
    
    // options.sync를 사용할 때는 Vuetify가 자동으로 초기화 이벤트를 발생시킴
    // 따라서 mounted에서 별도로 initialize 호출할 필요 없음
  },
  methods: {
    getTestId(testId) {
      return getTestId(testId);
    },
    /**
     * 기존의 sort기능을 사용하지 않도록 처리
     */
    customSort(items, _index, _isDesc) {
      return items;
    },
    /**
     * tableUtils를 사용한 정렬 파라미터 변환
     * @param {Array} sortBy - 정렬할 필드들
     * @returns {Array} API 요청용 정렬 필드 배열
     */
    changeSortByArrayToApiParam(sortBy) {
      // tableUtils의 buildSortParam을 사용하여 정렬 파라미터 생성
      if (sortBy && sortBy.length > 0) {
        const sortableFields = {
          'name': 'name',
          'description': 'description',
          'id': 'id'
        };
        
        // buildSortParam은 전체 정렬 파라미터를 반환하므로 필드만 추출
        const sortParam = buildSortParam(sortBy, this.tableOptions.sortDesc, sortableFields);
        const [field] = sortParam.split(',');
        return [field];
      }
      return ["id"];
    },
    changedOptions(val) {
      /**
       * groupBy : Array, groupDesc : Array, itemsPerPage : Number, multiSort : Boolean, mustSort : Boolean, page : Number, sortBy : Array, sortDesc : Array
       */

      
      // tableOptions는 이미 자동으로 업데이트됨
      // 별도로 변경할 필요 없음
      
      // 초기 로드 시에도 데이터를 가져오기 위해 searchProjectData 호출
      this.searchProjectData(
        this.search, 
        this.page, 
        this.tableOptions.sortBy, 
        this.tableOptions.sortDesc
      );
    },
    
    /**
     * tableUtils를 사용한 project 데이터 조회
     * @param {string} keyword - 검색 키워드
     * @param {number} page - 페이지 번호
     * @param {Array} sortBy - 정렬 필드
     * @param {Array} sortDesc - 정렬 방향
     */
    searchProjectData(keyword, page, sortBy, sortDesc) {
      
      const request = this.beginCrudTableRequest();
      this.apiLoading = true;
      
      // tableUtils를 사용하여 정렬 파라미터 생성
      const sortableFields = {
        'name': 'name',
        'description': 'description',
        'id': 'id'
      };
      
      const sortParam = buildSortParam(sortBy || this.tableOptions.sortBy, sortDesc || this.tableOptions.sortDesc, sortableFields);
      const pagination = buildPaginationParams(page || this.page, this.itemsPerPage);
      
      // URL 인코딩 방지를 위해 직접 쿼리 스트링 구성
      let queryParams = [];
      
      if (keyword && keyword.trim()) {
        queryParams.push(`keyword=${encodeURIComponent(keyword.trim())}`);
      }
      
      queryParams.push(`size=${pagination.size}`);
      queryParams.push(`page=${pagination.page}`);
      queryParams.push(`sort=${sortParam}`); // 인코딩 없이 직접 추가
      
      const queryString = queryParams.join('&');
      const apiUrl = `/${this.domain}?${queryString}`;
      

      
      Api.read(apiUrl, { signal: request.signal })
        .then((res) => {
          if (!this.isCrudTableRequestCurrent(request.token)) return;

          
          // API 응답 구조 확인 후 직접 처리
          if (res.data?.content?.content && Array.isArray(res.data.content.content)) {
            // 기존 API 응답 구조 사용
            const items = res.data.content.content.map((item) => ({
              name: item?.name,
              description: item?.description,
              id: item?.id,
            }));
            
            this.projects = items;
            this.pageCount = res.data.content.page?.totalPages || 0;
            this.page = (res.data.content.page?.number || 0) + 1;
            

          } else {
            // tableUtils를 사용하여 응답 데이터 변환 (대안)
            try {
              const transformedData = transformApiResponse(res, (items) => {

                const transformed = items.map((item) => ({
                  name: item?.name,
                  description: item?.description,
                  id: item?.id,
                }));

                return transformed;
              });
              

              
              // 변환된 데이터로 상태 업데이트
              this.projects = transformedData.items;
              this.pageCount = transformedData.pageCount;
              this.page = transformedData.page;
              
            } catch (error) {
              console.error("tableUtils 변환 에러:", error);
              // 에러 발생 시 빈 배열로 설정
              this.projects = [];
              this.pageCount = 0;
              this.page = 1;
            }
          }
          
        })
        .catch((error) => {
          if (!this.isCrudTableRequestCurrent(request.token)) return;
          console.error("API 호출 에러:", error);
          // 에러 발생 시 빈 배열로 설정
          this.projects = [];
          this.pageCount = 0;
          this.page = 1;
        })
        .finally(() => {
          if (!this.isCrudTableRequestCurrent(request.token)) return;
          this.apiLoading = false;
          this.finishCrudTableRequest(request.token);
        });
    },
    initialize() {
      //changedOptions에서 실행함
      this.searchProjectData();
    },
    openAddDialog() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = this[`${this.domain}`].indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      let index = this[`${this.domain}`].indexOf(item);
      confirm(this.$t("common.confirmDeleteSelected")) && (
        this.apiLoading = true,
        Api.delete(`/${this.domain}/${item.id}`, item)
          .then(() => {
            this[`${this.domain}`].splice(index, 1);
            this.initialize();
          })
          .catch(() => {
            this.$eventBus.$emit("alert-on", {
              on: true,
              message: "Delete failed",
              status: "error",
            });
          })
          .finally(() => {
            this.apiLoading = false;
          })
      );
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      this.$eventBus.$emit("request-data", { open: true });
      this.apiLoading = true;
      this.editedItem.owner = this.userProfile.id;

      this.paging = false;
      if (this.editedIndex > -1) {
        let index = this.editedIndex;
        Api.update(`/${this.domain}/${this.editedItem.id}`, this.editedItem)
          .then((res) => {
            Object.assign(this[`${this.domain}`][index], res.data);
            this.$eventBus.$emit("request-data", { open: false });
            this.$eventBus.$emit("alert-on", {
              on: true,
              message: "Edit Success!",
              status: "success",
            });
            this.initialize();
          })
          .catch(() => {
            this.$eventBus.$emit("request-data", { open: false });
            this.$eventBus.$emit("alert-on", {
              on: true,
              message: "Edit failed",
              status: "error",
            });
          })
          .finally(() => {
            this.close();
            this.$eventBus.$emit("request-data", { open: false });
            this.paging = true;
            this.apiLoading = false;
          });
      } else {
        Api.create(`/${this.domain}`, this.editedItem)
          .then((res) => {
            this[`${this.domain}`].push(res.data);
            this.$eventBus.$emit("request-data", { open: false });
            this.initialize();
          })
          .catch(() => {
            this.$eventBus.$emit("request-data", { open: false });
            this.$eventBus.$emit("alert-on", {
              on: true,
              message: "input failed",
              status: "error",
            });
          })
          .finally(() => {
            this.close();
            this.paging = true;
            this.apiLoading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.custom-padding {
  padding: 8px 12px !important;
}
</style>
